import {
  DayOfWeek,
  HolidayApiResponse,
  WorkingHourItem,
  WorkingHoursMap,
} from "../../types";
import { normalizeDate } from "@shared/utils/dateUtils";

export const formatDateKey = (date: Date): string => {
  if (!date || isNaN(date.getTime())) {
    return "";
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const formatDisplayDate = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatTime = (time: string): string => {
  if (!time) {
    return "";
  }

  const parts = time.toString().split(":");
  if (parts.length < 2) {
    return time; // Return original if can't parse
  }

  const [hoursStr, minutesStr] = parts;
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // If parsing fails, return original
  if (isNaN(hours) || isNaN(minutes)) {
    return time;
  }

  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;

  return `${displayHour}:${minutesStr.padStart(2, "0")} ${ampm}`;
};

export const timeToSliderValue = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

export const sliderValueToTime = (value: number): string => {
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

export const formatMonthYear = (date: Date): string => {
  const month = date.toLocaleString("default", { month: "long" }); // e.g. "July"
  const year = date.getFullYear();
  return `${month} ${year}`;
};

export const transformHolidayApiToMap = (
  apiData: HolidayApiResponse,
  normalizeFn: (date: any) => string = normalizeDate
) => {
  const map: Record<string, { type: "federal" | "company" | "observed" }> = {};
  apiData.result.forEach((holiday) => {
    // Directly use the YYYY-MM-DD string as the key to avoid timezone shifts
    const key = normalizeFn(holiday.date);
    map[key] = {
      type: holiday.leaveTypeDisplay.toLowerCase() as
        | "federal"
        | "company"
        | "observed",
    };
  });
  return map;
};

export const transformToWorkingHoursMap = (
  items: WorkingHourItem[],
): WorkingHoursMap => {
  const map = {} as WorkingHoursMap;

  items.forEach((item) => {
    const key = item.name.toLowerCase() as DayOfWeek;
    map[key] = {
      isWorking: item.isActive,
      startTime: item.startTime,
      endTime: item.endTime,
    };
  });

  return map;
};
